import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { DriverReport } from "../../../model/report/driverReport";
import * as moment from "moment";
import { localeSwedish } from "../../locale.swedish";
import { AgGridAngular } from "ag-grid-angular";
import { activityAbbreviations, AdminEnum, BusEnum, EventTypes } from "../../../common/enums";
import { ColDef, GridOptions } from "ag-grid-community";

@Component({
  selector: "app-driver-report-details",
  templateUrl: "./driver-report-details.component.html",
  styleUrls: ["./driver-report-details.component.css"],
})
export class DriverReportDetailsComponent implements OnInit {
  @Input() driverReport: DriverReport;
  @ViewChild("shifts", { static: true }) shifts: AgGridAngular;
  @ViewChildren("activities") activities: QueryList<AgGridAngular>;

  public localeText = {};

  workshiftColumnDefs: ColDef[] = [
    {
      headerName: "Buss",
      field: "busNumber",
      width: 100,
    },
    {
      headerName: "Påbörjades",
      field: "start",
      width: 150,
      cellRenderer: (result) => {
        return result.data.start ? this.getTime(result.data.start) : "";
      },
    },
    {
      headerName: "Avslutades",
      field: "end",
      width: 150,
      cellRenderer: (result) => {
        return result.data.end ? this.getTime(result.data.end) : "";
      },
    },
  ];

  activitiesColumnDefs: ColDef[] = [
    {
      headerName: "Typ",
      field: "type",
      width: 180,
      sortingOrder: ["asc", "desc"],
      cellRenderer: (result) => {
        let abb = activityAbbreviations.find(
          (x) => x.state == result.data.type
        );
        return abb ? abb.translated : result.data.type;
      },
    },
    {
      headerName: "Påbörjades",
      field: "started",

      width: 150,
      cellRenderer: (result) => {
        return result.data.started ? this.getTime(result.data.started) : "";
      },
    },
    {
      headerName: "Avslutades",
      field: "ended",
      width: 150,
      cellRenderer: (result) => {
        return result.data.ended ? this.getTime(result.data.ended) : "";
      },
    },
  ];
  public gridOptionsWs: GridOptions = {
    columnDefs: this.workshiftColumnDefs
  }
  public gridOptionsAct: GridOptions = {
    columnDefs: this.activitiesColumnDefs
  }
  constructor() { }

  ngOnInit(): void {
    this.localeText = localeSwedish;
  }

  isAdminOrMisc(assignment) {
    let isAdminOrMisc = assignment.type === BusEnum.Admin || assignment.type === BusEnum.Misc;
    return isAdminOrMisc;
  }

  isTransfer(assignment) {
    return assignment.type === BusEnum.Transfer;
  }

  getEvent(assignment) {
    let event = EventTypes.find((x) => x.name === assignment.description);
    if (event) return event;
    return EventTypes.find((x) => x.name === AdminEnum.Misc);

  }

  getIcon(assignment) {
    try {
      if (
        assignment.type === BusEnum.Admin ||
        assignment.type === BusEnum.Misc
      ) {
        let event = EventTypes.find((x) => x.name === assignment.description);
        return event ? event.icon : "";
      } else if (assignment.type === BusEnum.Air) {
        return assignment.arrival ? "arrow_downward" : "arrow_upward";
      } else {
        return "directions_bus";
      }
    } catch (error) {
      console.log(error);
    }
  }

  private getTime(date: Date) {
    return moment(date).format("HH:mm");
  }
}
